// extracted by mini-css-extract-plugin
export default {"initial":"Blank_initial__ernZV","icon":"Blank_icon__3088b","text":"Blank_text__A8nDg"};